<template>
    <div name="receipt" v-if="receipt" class="receipt" id="receipt">
        <span class="text-16-600">신용·체크카드 매출전표</span>
        <div class="line" style="margin-top: 30px;"></div>
        <span class="text-14-400-gray" style="margin-top: 30px;">결제 정보</span>
        <div class="space-between" style="margin-top: 8px;">
            <span class="text-16-400">구매자</span>
            <span class="text-16-400" >{{ receipt.buyer }}</span>
        </div>
        <div class="space-between" style="margin-top: 15px;">
            <span class="text-16-400">주문번호</span>
            <span class="text-16-400">{{ receipt.reception_number }}</span>
        </div>
        <div class="line" style="margin-top: 30px;"></div>
        <span class="text-14-400-gray" style="margin-top: 30px;">결제 수단</span>
        <div class="space-between" style="margin-top: 8px;">
            <span class="text-16-400">카드명</span>
            <span class="text-16-400">{{ receipt.card_name }}</span>
        </div>
        <div class="space-between" style="margin-top: 15px;">
            <span class="text-16-400">카드번호</span>
            <span class="text-16-400">{{ receipt.card_number }}</span>
        </div>
        <div class="space-between" style="margin-top: 15px;">
            <span class="text-16-400">승인번호</span>
            <span class="text-16-400">{{ receipt.auth_no }}</span>
        </div>
        <div class="space-between" style="margin-top: 15px;">
            <span class="text-16-400">할부여부</span>
            <span class="text-16-400">{{ convertToInstallment(receipt.installment) }}</span>
        </div>
        <div class="space-between" style="margin-top: 15px;">
            <span class="text-16-400">거래일시</span>
            <span class="text-16-400">{{ convertDateTime(receipt.pay_date) }}</span>
        </div>
        <div class="line" style="margin-top: 30px;"></div>
        <div class="space-between" style="margin-top: 30px;">
            <span class="text-16-400">총 결제금액</span>
            <span class="text-20-700">{{ setComma(receipt.total_fee) }}</span>
        </div>
        <div class="space-between" style="margin-top: 20px;">
            <span class="text-16-400">판매금액</span>
            <span class="text-16-400">{{ setComma(receipt.total_fee) }}</span>
        </div>
        <div class="line" style="margin-top: 30px;"></div>
        <span class="text-14-400-gray" style="margin-top: 30px;">이용상점</span>
        <span class="text-14-400-gray" style="margin-top: 4px;">솔닥 주식회사 (Soldoc Co., Ltd.) | 대표자명: 김민승, 이호익 | 사업자등록번호: 284-87-00967 | 전화: 02-6954-7676 | 주소: 서울 강남구 학동로33길 17, 3층</span>
    </div>
</template>

<script>
import Convert from '@/utilities/convert';

export default {
    name: 'receipt',
    props: ['receipt'],
    mounted: function()
    {
        // alert(JSON.stringify(this.receipt))
    },
    methods: {
        setComma: function(data)
        {
            return Convert.setComma(data);
        },
        convertToInstallment: function(number)
        {
            return number === 0 ? '-' : `${number}개월`
        },
        convertDateTime: function(timestamp){
            return Convert.convertTimeStampToStringDateTime(timestamp);
        }
    }
}
</script>

<style scoped>
    .receipt {
        width: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 30px 16px;
    }
    .line {
        width: 100%;
        height: 1px;
        background: #E8EAEE;
    }
    .text-16-400 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    } 
    .text-16-600 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 150% */
    }
    .text-20-700 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    .text-14-400-gray {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .space-between {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
  
</style>


// WEBPACK FOOTER //
// src/components/molecules/Receipt.vue